export default __webpack_public_path__ + "static/fAiFUDYH-41cc5a24c015f016d57a7776187d9449.svg";